import { HttpService } from '@/services/httpService'
import { Auth } from '@/types/common/httpRequest'
import { CompleteVoucherResponse } from '@/types/pos/referral'

type CompleteVoucherRequest = {
    voucherCode: string
    walletId: number
    identifier: string
    amount: number
}

const api = {
    completeVoucher:
        '/common/voucher/{voucherCode}/vendor/{walletId}/{identifier}/complete'
}

const completeVoucher = async (request: CompleteVoucherRequest) => {
    return HttpService.Post<CompleteVoucherResponse>(
        api.completeVoucher
            .replace('{voucherCode}', request.voucherCode)
            .replace('{walletId}', String(request.walletId))
            .replace('{identifier}', request.identifier),
        { amount: request.amount },
        Auth.Cashier
    )
}

export const voucherCompletionService = {
    completeVoucher
}

export type { CompleteVoucherRequest }
